let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("irp9Q")).then(() => parcelRequire('cxt3a'));